import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { DataGrid } from '@mui/x-data-grid';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setCurrentExperiment } from '../store/ExperimentSlice';
import { selectOpenIssues } from '../store/IssuesSlice';

const columns = [
    { field: 'experimentEntry', headerName: 'Experiment ID', flex: 2,
        valueGetter: (experimentEntry) => {
            return experimentEntry.name
        }
    },
    { field: 'id', headerName: 'Issue ID', flex: 1,
        valueGetter: (id) => {
            return `Issue ${id}`
        }
    },
    { field: 'title', headerName: 'Title', flex: 5 },
]

function Title() {
    return (
        <Box style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", paddingTop: "10px" }}>
            <Typography variant="h5">Open Issues</Typography>
        </Box>
    )
}

function OpenIssuesTable() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const openIssues = useSelector(selectOpenIssues)

    const accessExperiment = (experiment) => {
        navigate(`/access/${experiment.timestamp}`);
      }

      const handleRowClick = (rowClicked) => {
        dispatch(setCurrentExperiment(rowClicked.row.timestamp))
        accessExperiment(rowClicked.row.experimentEntry)
    };


    return (
        <DataGrid
            sx={{ marginLeft: 2, marginBottom: 6 }} 
            rows={openIssues}
            columns={columns}
            onRowClick={handleRowClick}
            slots={{ toolbar: Title }}
            getRowId={(row) => `${row.id}-${row.experimentEntry.name}`}
            initialState={{
                pagination: {
                    paginationModel: {
                        pageSize: 5,
                    },
                },
            }}
            pageSizeOptions={[5, 10, 15]}
            disableRowSelectionOnClick
            autoHeight={true}
        />
    )
}

export default OpenIssuesTable;